<tilby-info-panel [nomeDevice]="operatorName" [nomeStore]="shopName" [btns]="btns" class="tw-w-full"/>
